import { AccessLevelEnum } from '@zaoblako/shared/modules/security/enums/access.level.enum';
import { FdoAccessRulesKeyEnum } from '@zaoblako/web/core/models/enums/access-rules/fdo/fdo-access-rules-key.enum';

type AccessRuleExpression = Record<string, any>;

export const FdoAccessRulesConst: Record<FdoAccessRulesKeyEnum, AccessRuleExpression> = {
  // --- Модуль FDO ---
  // --- Раздел FDO.SECTIONS.FDO ---

  [FdoAccessRulesKeyEnum.FDO_FDO_KKT_READ]: {
    'FDO.enabled': true,
    'FDO.sections.FDO.tabs.KKT.accessLevel': { $gte: AccessLevelEnum.READ }
  },
  [FdoAccessRulesKeyEnum.FDO_FDO_KKT_WRITE]: {
    'FDO.enabled': true,
    'FDO.sections.FDO.tabs.KKT.accessLevel': { $gte: AccessLevelEnum.WRITE }
  },

  [FdoAccessRulesKeyEnum.FDO_FDO_RECEIPT_READ]: {
    'FDO.enabled': true,
    'FDO.sections.FDO.tabs.RECEIPT.accessLevel': { $gte: AccessLevelEnum.READ }
  },
  [FdoAccessRulesKeyEnum.FDO_FDO_RECEIPT_WRITE]: {
    'FDO.enabled': true,
    'FDO.sections.FDO.tabs.RECEIPT.accessLevel': { $gte: AccessLevelEnum.WRITE }
  },

  [FdoAccessRulesKeyEnum.FDO_FDO_KKT_ACTIVITY_READ]: {
    'FDO.enabled': true,
    'FDO.sections.FDO.tabs.KKT_ACTIVITY.accessLevel': { $gte: AccessLevelEnum.READ }
  },

  [FdoAccessRulesKeyEnum.FDO_FDO_ACTIVITY_READ]: {
    'FDO.enabled': true,
    'FDO.sections.FDO.tabs.ACTIVITY.accessLevel': { $gte: AccessLevelEnum.READ }
  },
  [FdoAccessRulesKeyEnum.FDO_FDO_ACTIVITY_WRITE]: {
    'FDO.enabled': true,
    'FDO.sections.FDO.tabs.ACTIVITY.accessLevel': { $gte: AccessLevelEnum.WRITE }
  }
};
